import { IssueModel } from 'shared/domain/issue/issueModel';
import { DocumentInDto } from 'shared/dtos/in/document';
import { classifyDocumentsForPdfEstimate } from 'shared/domain/report/estimate/classifyDocumentsForPdfEstimate';

type IssuePrimaryDataWithOptionalDocuments = IssueModel['primaryData'] & {
  documents?: DocumentInDto[];
};

function readPrimaryDocuments(
  issue: IssueModel
): DocumentInDto[] | undefined {
  return (issue.primaryData as IssuePrimaryDataWithOptionalDocuments | undefined)
    ?.documents;
}

function hasKnownPrimaryAttachment(issue: IssueModel): boolean {
  if (Boolean(issue.mainImage)) {
    return true;
  }

  const documents = readPrimaryDocuments(issue);
  if (!documents) {
    return false;
  }

  return classifyDocumentsForPdfEstimate(documents).all > 0;
}

function hasUnknownPrimaryAttachmentsState(issue: IssueModel): boolean {
  return !issue.mainImage && readPrimaryDocuments(issue) === undefined;
}

export function anyInspectionIssueHasAttachments(
  issues: IssueModel[]
): boolean {
  if (issues.length === 0) {
    return false;
  }

  if (issues.some(hasKnownPrimaryAttachment)) {
    return true;
  }

  // Multi-issue payloads can omit primary documents entirely.
  // Fail-open to avoid disabling a section when attachment state is unknown.
  return issues.some(hasUnknownPrimaryAttachmentsState);
}
